/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedShippingInfoLink_shipmentQuote$ref = any;
type PdpSharedShippingInfo_shipmentQuote$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedDetailShipping_shipmentQuote$ref: FragmentReference;
export type PdpSharedDetailShipping_shipmentQuote = {|
  +subTotalAmount: ?{|
    +amount: ?number
  |},
  +isCustom: ?boolean,
  +isNew: ?boolean,
  +status: ?string,
  +$fragmentRefs: PdpSharedShippingInfoLink_shipmentQuote$ref & PdpSharedShippingInfo_shipmentQuote$ref,
  +$refType: PdpSharedDetailShipping_shipmentQuote$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedDetailShipping_shipmentQuote",
  "type": "ShipmentQuote",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "subTotalAmount",
      "storageKey": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "amount",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isCustom",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isNew",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "status",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfoLink_shipmentQuote",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfo_shipmentQuote",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'fe870b7c7d5e5e507327b4d9b91f30f8';
module.exports = node;
